import { getApiUrl } from "../utils/get-api-url";

export interface getSearchResultsProps {
  searchTerm?: string;
  quotes: boolean;
  policies: boolean;
  userId: string;
  pageSize: number;
  from: number;
  resultsetType: string;
  sortFields: string;
  sortDir: string;
  showAll: boolean;
  filters?: unknown;
  orFilters?: unknown;
  rangeFilters?: unknown;
}

export const getSearchResults = async (payload: getSearchResultsProps) => {
  const apiUrl = getApiUrl("quotesapi");
  const fullUrl = `${apiUrl}/quotes/search`;

  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });

  const { headers: resHeaders, status, ok } = response;
  const contentType = resHeaders.get("content-type");

  if (!contentType || !contentType.includes("application/json")) {
    throw new Error("Network request failed. Status: " + status);
  }
  const result = await response.json();

  if (!ok) throw new Error(result.message || "Quotes API request failed");

  return result;
};

export const getCSVDownload = async (payload: getSearchResultsProps) => {
  const apiUrl = getApiUrl("quotesapi");
  const fullUrl = `${apiUrl}/quotes/search/reports`;

  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      Accept: "text/csv",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    credentials: "include",
    body: JSON.stringify(payload)
  });

  const { headers: resHeaders, status, ok } = response;
  if (!ok) throw new Error("Failed to fetch the CSV from our server.");

  const contentType = resHeaders.get("content-type");

  if (!contentType || !contentType.includes("text/csv")) {
    throw new Error("Network request failed. Status: " + status);
  }

  const bytes = await response.arrayBuffer();
  const blob = new Blob([bytes], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "policies-export.csv";
  a.target = "_blank";
  a.click();
  window.URL.revokeObjectURL(url);
};
